import React, { useEffect, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import "./PPClasses.css";
import Header from "../../Header/Header";
import Tooltip from "react-bootstrap/Tooltip";
import { post } from "../../../app/shared/http";
import { Modal, OverlayTrigger } from "react-bootstrap";
import loadingIcon from "../../Spinner/loadingIcon.gif";
import { withAuth, handleResponse, handleJwtTokenForKeppMeLoggedIn } from "../../../app/util/HOC";
export function PPClassStudentsDetails() {
    const { isbn } = useParams();
    const history = useHistory();
    const location = useLocation();
    const classParams = location.state.ppClassInfo;
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const ppProductId = localStorage.getItem('ppProductTagId');
    const { ppClassName, ppClassId, ppClassDescription } = classParams;
    const ppPageInfo = JSON.parse(localStorage.getItem('ppLandingInfo'));
    const ppIsbn = (isbn && isbn !== 'undefined') ? isbn : localStorage.getItem('bookIsbn');
    const studSearchDropdownResFromSess = localStorage.getItem('studSearchDropdownRes') ? localStorage.getItem('studSearchDropdownRes') : "firstName";
    const [ppClassInfo, setPPClassInfo] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [studSearchTerm, setStudSearchTerm] = useState('');
    const [studClassDropId, setStudClassDropId] = useState();
    const [failedFetching, setFailedFetching] = useState(false);
    const [hasMoreStudents, setHasMoreStudents] = useState(true);
    const [classStudDetails, setClassStudDetails] = useState([]);
    const [studentFilteredData, setStudentFilteredData] = useState();
    const [isStudentsLoading, setIsStudentsLoading] = useState(false);
    const [studClassDropFlag, setStudClassDropFlag] = useState(false);
    const [studClassDropPopupShow, setStudClassDropPopupShow] = useState(false);
    const [studSearchDropdownRes, setStudSearchDropdownRes] = useState(studSearchDropdownResFromSess);
    useEffect(() => {
        if (hasMoreStudents || studClassDropFlag) {
            getStudentDetailsForClass();
            setStudClassDropFlag(false);
        }
    }, [currentIndex, studClassDropFlag]);
    function getStudentDetailsForClass() {
        setIsStudentsLoading(true);
        let reqtData = {
            "ppClassVO": {
                "ppClassId": ppClassId,
                "ppguidId": ppProductId,
                "ppClassName": ppClassName,
            },
            "pagination": { "offset": currentIndex }
        }
        post("/PP/Professor/getStudentDetailsForClassV2", reqtData, 'qpAPI')
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then(data => {
                setIsStudentsLoading(false);
                if (data) {
                    setClassStudDetails(data);
                    setPPClassInfo(prevData => {
                        if (studClassDropFlag) {
                            setStudClassDropFlag(false);
                            const newPrevData = prevData.filter((data) => data.userId !== studClassDropId);
                            return [...newPrevData, ...data.StudentList];
                        }
                        return [...prevData, ...data.StudentList]
                    });
                    setHasMoreStudents(data.StudentList.length > 0);
                }
            }).catch(error => {
                setFailedFetching(true);
                setIsStudentsLoading(false);
                console.error("There has been a problem with your fetch operation:", error);
            })
    }
    function studentDropClass() {
        let reqData = {
            "ppClassVO": {
                "ppClassName": "",
                "ppClassId": ppClassId,
                "ppguidId": ppProductId,
                "studentUserId": studClassDropId,
            }
        }
        post("/PP/Professor/dropStudentFromClass", reqData, 'qpAPI')
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then(data => {
                if (data) {
                    setStudClassDropFlag(true);
                    setStudClassDropPopupShow(false);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const handleStudTabClick = (tabName) => {
        if (tabName === 'students') {
            history.push(`/pp-classes/${isbn}/pp-studentsdetails`, { ppClassInfo: classParams });
        } else if (tabName === 'topicScores') {
            history.push(`/pp-classes/${isbn}/pp-studentstopicscores`, { ppClassInfo: classParams, ppStudentInfo: classStudDetails });
        }
    }
    const handleStudentDropClass = (dropStudId) => {
        setStudClassDropPopupShow(true);
        setStudClassDropId(dropStudId);
    }
    var studentSearchData = [];
    const studentArrList = ppClassInfo || [];
    if (studSearchTerm !== '') {
        localStorage.setItem("studSearchDropdownRes", studSearchDropdownResFromSess);
        let studentListData = studentArrList
        let studentListFilteredData = studentListData && studentListData.filter((ppClassStudent, ind) => {
            let studentData = (ppClassStudent.firstName + ' ' + ppClassStudent.lastName).toLowerCase().includes(studSearchTerm.toLowerCase());
            if (studentData) { return studentData; }
            else { return false; }
        });
        studentSearchData = studentListFilteredData;
    }
    var studentSearchData = (studentSearchData && studSearchTerm !== '') ? studentSearchData : studentArrList;
    if (studSearchDropdownRes !== '') {
        localStorage.setItem("studSearchDropdownRes", studSearchDropdownRes);
        if (studSearchDropdownRes == "firstName") {
            let studentSearchDataDropRes = studentSearchData.sort(
                (ppClassStudent1, ppClassStudent2) => (ppClassStudent1.firstName + ' ' + ppClassStudent1.lastName).localeCompare(ppClassStudent2.firstName + ' ' + ppClassStudent2.lastName)
            );
            studentSearchData = studentSearchDataDropRes;
        } else if (studSearchDropdownRes == "lastName") {
            let studentSearchDataDropReslsn = studentSearchData.sort(
                (ppClassStudent1, ppClassStudent2) => (ppClassStudent1.lastName).localeCompare(ppClassStudent2.lastName)
            );
            let studentSearchDataDropResLn = studentSearchDataDropReslsn.sort(
                (ppClassStudent1, ppClassStudent2) => (ppClassStudent1.lastName + ' ' + ppClassStudent1.firstName).localeCompare(ppClassStudent2.lastName + ' ' + ppClassStudent2.firstName)
            );
            studentSearchData = studentSearchDataDropResLn;
        } else if (studSearchDropdownRes == "numberOfQuizzesCompleted") {
            let studentSearchDataDropResNum = studentSearchData.sort(
                (ppClassStudent1, ppClassStudent2) => (ppClassStudent1.firstName + ' ' + ppClassStudent1.lastName).localeCompare(ppClassStudent2.firstName + ' ' + ppClassStudent2.lastName)
            );
            let studentSearchDataDropResOr = studentSearchDataDropResNum.sort((a, b) => {
                const aLength = Number.parseInt(a.numberOfQuizzesCompleted);
                const bLength = Number.parseInt(b.numberOfQuizzesCompleted);
                return aLength > bLength ? -1 : 1;
            });
            studentSearchData = studentSearchDataDropResOr;
        }
    }
    let studFilteredData = (studSearchDropdownRes !== '' || studSearchTerm !== '') ? studentSearchData : studentArrList;
    const studInfoToolTip = {
        classDropStud: <Tooltip id="tooltip" className="ppClassDropTooltip"> Drop Student</Tooltip>,
        quizCompltStud: <Tooltip id="tooltip" className="ppClassDropTooltip"> Number of distinct graded video quizzes submitted by a student.</Tooltip>
    }
    return (
        <>
            <Header userVO={userVO} pageName="PPClassStudentsDetails" isbn={ppIsbn}></Header>
            <div className='container'>
                <div className="card ppClassContainerSection">
                    <div className="card-body ppvContainerCard">
                        <div className="row">
                            <div className="col-12 p-0">
                                {
                                    ppPageInfo &&
                                    <div className="ppvLogoContainer pt-4">
                                        <p>
                                            <span className='ppvCommonStyle ppvLogoBoldText'>PracticePerfect</span>
                                            <span className='ppvCommonStyle ppvLogoText'>{ppPageInfo.ProductName}</span>
                                        </p>
                                    </div>
                                }
                                <div className="sticky-top TS-TabFirstSticky">
                                    <div className="titleDesp-heights pt-2">
                                        <h4 className={ppClassName.length > 84 ? "ppClassesTitle ppClassesTitleGT mb-1" : "ppClassesTitle ppClassesTitleLT mb-1"}>{ppClassName}</h4>
                                        {
                                            ppClassDescription !== "" ?
                                                <p className={ppClassDescription.length > 168 ? "ppClassesDescp h6 pt-xl-3 pt-lg-3 pt-md-3 ppClassesDescpGT" : "ppClassesDescp h6 pt-xl-3 pt-lg-3 pt-md-3 ppClassesDescpLT"}>{ppClassDescription}</p> : null
                                        }
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding mt-4 ">
                                        <ul className="nav nav-tabs navtab-color">
                                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-xs-12 no-padding">
                                                <li>
                                                    <a className="nav-link cqStdDetailsTiltleTab active" onClick={() => handleStudTabClick('students')}>
                                                        Students
                                                    </a>
                                                </li>
                                            </div>
                                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-xs-12 no-padding">
                                                <li>
                                                    <a className="nav-link cqStdDetailsTiltleTab" onClick={() => handleStudTabClick('topicScores')}>
                                                        Topic Scores
                                                    </a>
                                                </li>
                                            </div>
                                        </ul>
                                        <div className="dashBoardSearchIconDivs mt-4">
                                            <input data-testid="search_input" title="Search inside your books for topics, cases, or keywords" id="searchStudentsId" className="classStdSearchInput" type="text" placeholder="Search Student" value={studSearchTerm} onChange={(e) => setStudSearchTerm(e.target.value)} />
                                            <i data-testid="search" className='fa fa-search classStdSearchIcon text-dark' title='Search inside your books for topics, cases, or keywords'></i>
                                        </div>
                                        {
                                            classStudDetails ?
                                                <div className="StdDetailTableTitle mt-3">
                                                    {classStudDetails.total_no_of_students_enrolled === 1 ?
                                                        `There is ${classStudDetails.total_no_of_students_enrolled} student currently enrolled in this class.` :
                                                        `There are ${classStudDetails.total_no_of_students_enrolled} students currently enrolled in this class.`
                                                    }
                                                </div> : null
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-7 col-lg-6 col-md-5 col-sm-12 col-12">
                                        <div className="cqProfQuizResultTitleContainer col-xl-7 col-lg-8 col-md-12 col-sm-12 col-12">
                                            <h3 className='cqProfQuizResultTitle'>Students</h3>
                                        </div>
                                    </div>
                                    <div className='col-xl-5 col-lg-6 col-md-7 col-sm-12 col-12'>
                                        <div className="cqProfQuizResultSortByPadding row">
                                            <div className="cqProfQuizResultViewingLabel col-xl-4 col-lg-4 col-md-3 col-sm-3 col-3" >
                                                <p className='cqProfQuizResultSortBY text-xl-right text-lg-right text-md-right text-sm-left text-left pl-2' style={{ paddingTop: "4px" }}>Sort By:</p>
                                            </div>
                                            <div className="col-xl-8 col-lg-8 col-md-9 col-sm-9 col-9 pl-xl-3 pl-lg-3 pl-md-2 pl-sm-0 pl-0" style={{ paddingRight: '9px' }}>
                                                <select data-testid="sort_students" aria-label="Sort by" className="cqProfQuizResultSortBySelect" value={studSearchDropdownRes} onChange={(e) => setStudSearchDropdownRes(e.target.value)}>
                                                    <option value="firstName">First Name</option>
                                                    <option value="lastName">Last Name</option>
                                                    <option value="numberOfQuizzesCompleted">No. of quizzes completed</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={ppClassDescription !== "" ? "tableFixHead tableFixHeadGT65" : (ppClassName.length > 65 ? 'tableFixHead tableFixHeadGT65-NoDesp' : 'tableFixHead tableFixHeadLT65-NoDesp')}>
                                    <table className="table mt-3 studentTableWidth">
                                        <thead className={ppClassDescription !== "" ?
                                            (ppClassName.length > 84 ? "stickyStudentTabTable-th stickyStudentTabTableGT-th" : "stickyStudentTabTable-th stickyStudentTabTableLT-th") :
                                            (ppClassName.length > 84 ? 'stickyStudentTabTable-th stickyStudentNODespTabTableGT-th' : "stickyStudentTabTable-th stickyStudentNODespTabTableLT-th")
                                        }>
                                            <tr className="border-top-0">
                                                <th className="StdDetailTableTitle p-1">
                                                    {/* Kept this line, to be used in future <input type="checkbox" /> */}
                                                    <span className="ml-1">Name</span>
                                                </th>
                                                <th className="StdDetailTableTitle p-1 qcTitleWidth">
                                                    <div className="d-flex">
                                                        <div className="">
                                                            <OverlayTrigger placement="top" overlay={studInfoToolTip.quizCompltStud}>
                                                                <i className='fa fa-info-circle text-primary mr-1 classTabIconsColor'></i>
                                                            </OverlayTrigger>
                                                        </div>
                                                        <div className="">
                                                            <span>No. of quizzes completed</span>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th className="StdDetailTableTitle p-1 TableStatusTitle">Status</th>
                                            </tr>
                                        </thead>
                                        {
                                            studFilteredData && studFilteredData.length > 0 ?
                                                <tbody className="border p-1">
                                                    {
                                                        studFilteredData.map((studentInfo, index) => (
                                                            <tr tabindex={0} className="border" key={index}>
                                                                <td className="StdDetailTableTitle p-1 text-break">
                                                                    <div className="d-flex">
                                                                        <div>
                                                                            {/* Kept this line, to be used in future <input className="" type="checkbox" /> */}
                                                                        </div>
                                                                        <div className="ml-1">
                                                                            <span className="">{studentInfo.firstName + ' ' + studentInfo.lastName}</span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="StdDetailTableTitle p-1 pr-xl-5 pr-lg-3 pr-md-5 pr-5 text-center qcTitleWidth qcPadding">{studentInfo.numberOfQuizzesCompleted}</td>
                                                                <td className="StdDetailTableTitle p-1 d-flex justify-content-between"><span className={studentInfo.productDurationMsg === 'Expired' ? 'expiredStatus' : ''}>{studentInfo.productDurationMsg}</span>
                                                                    <a data-testid="drop_student" className="d-xl-block d-lg-none d-md-none d-sm-none d-none" onClick={() => handleStudentDropClass(studentInfo.userId)} >
                                                                        <OverlayTrigger placement="top" overlay={studInfoToolTip.classDropStud} >
                                                                            <i className="fa fa-trash text-primary pl-1 pr-1 classTabIconsColor" aria-hidden="true" ></i>
                                                                        </OverlayTrigger>
                                                                    </a>
                                                                    <a data-testid="drop_student_icon" className="d-xl-none " onClick={() => handleStudentDropClass(studentInfo.userId)} >
                                                                        <i className="fa fa-trash text-primary pl-1 pr-1 " aria-hidden="true" ></i>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody> :
                                                <tbody>
                                                    <tr>
                                                        <td colSpan={10} style={{ textAlign: 'center', fontFamily: 'Fira Sans' }}>No student found</td>
                                                    </tr>
                                                </tbody>
                                        }
                                    </table>
                                    {
                                        isStudentsLoading && hasMoreStudents ?
                                            <div className="text-center">
                                                <img src={loadingIcon} width="20px" height="21px" alt=""></img>
                                            </div>
                                            : <div className="text-center" style={{ fontFamily: 'Fira Sans' }}></div>
                                    }
                                    {failedFetching && <div>Something went wrong. Please check your internet connection. If the issue still persists, please contact customer support.</div>}
                                </div>
                                <Modal className="modal fade" show={studClassDropPopupShow} onHide={() => setStudClassDropPopupShow(false)}
                                    size="md" aria-labelledby="contained-modal-title-vcenter"
                                    centered dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0">
                                    <div className='ppclassDeletePopUp pt-2' >
                                        <Modal.Header className='close text-right ppDropPopUpClose' closeButton />
                                        <p className="deleteClassPopUp-title pt-2">Before you proceed with dropping the student from the class, please note that you will no longer have access to their scores and activities.</p>
                                        <p className="deleteClassPopUp-text">Do you want to drop this student from the class?</p>
                                        <div className="text-center">
                                            <button className="btn btn-primary px-4 py-1 deletePopup-noBtn" onClick={() => setStudClassDropPopupShow(false)}>No</button>
                                            <button className="btn btn-light px-4 py-1 deletePopup-yesBtn ml-3" onClick={() => studentDropClass()}>Yes</button>
                                        </div>
                                    </div>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withAuth(PPClassStudentsDetails);